import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

type Props = {
  currentStep: number;
  textArray: string[];
};

const FormerStep: FC<{ label: string }> = ({ label }) => (
  <span className={`${styles.chartItem} ${styles.prev}`}>
    <span className={styles.chartItemPc}>
      <div className={styles.iconWrapper}>
        <Icon name="done" fontSize="16px" />
      </div>
    </span>
    <div className={styles.chartItemPcText({ isCurrentStep: false })}>{label}</div>
  </span>
);

const CurrentStep: FC<{ label: string; stepNum: number }> = ({ label, stepNum }) => (
  <span className={`${styles.chartItem} ${styles.current}`}>
    <span className={styles.chartItemPc}>{stepNum}</span>
    <div className={styles.chartItemPcText({ isCurrentStep: true })}>{label}</div>
  </span>
);

const LatterStep: FC<{ label: string; stepNum: number }> = ({ label, stepNum }) => (
  <span className={styles.chartItem}>
    <span className={styles.chartItemPc}>{stepNum}</span>
    <div className={styles.chartItemPcText({ isCurrentStep: false })}>{label}</div>
  </span>
);

export const DescriptionStepIndicator: FC<Props> = ({ currentStep, textArray }) => {
  return (
    <div className={styles.chartWrapper}>
      {textArray.map((label, index) => {
        const stepNum = index + 1;
        if (stepNum < currentStep) {
          return <FormerStep key={`${stepNum}-${label}`} label={label} />;
        }
        if (stepNum === currentStep) {
          return <CurrentStep key={`${stepNum}-${label}`} label={label} stepNum={stepNum} />;
        }
        return <LatterStep key={`${stepNum}-${label}`} label={label} stepNum={stepNum} />;
      })}
    </div>
  );
};
